import { render, staticRenderFns } from "./AddAmount.vue?vue&type=template&id=541531da&scoped=true"
import script from "./AddAmount.vue?vue&type=script&lang=js"
export * from "./AddAmount.vue?vue&type=script&lang=js"
import style0 from "./AddAmount.vue?vue&type=style&index=0&id=541531da&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541531da",
  null
  
)

export default component.exports